module.exports = __webpack_public_path__ + "static/media/text-light.20c83220.svg";